import type { QueryClient } from '@tanstack/react-query';

/** Refresh every active floor overlay after an app booking lifecycle write. */
export async function invalidateTwinStatusQueries(queryClient: QueryClient): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      predicate: (query) => typeof query.queryKey[0] === 'string'
        && /^\/api\/floors\/[^/]+\/(?:twin-status|bookings)$/.test(query.queryKey[0])
    }),
    queryClient.invalidateQueries({ queryKey: ['/api/availability/search'] })
  ]);
}
